/* global globals */
import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const requestApi = function requestApi(data, pathUrl) {
  const path = (pathUrl[0] === '/') ? pathUrl.substr(1) : pathUrl;

  let url = _.get(globals, 'apiWebroot', '/') + path;

  if (data !== null) {
    let params = '';
    for (const key in data) { // eslint-disable-line no-restricted-syntax
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (params !== '' || path.indexOf('?') !== -1) {
          params += '&';
        }
        params += key + '=' + encodeURIComponent(data[key]); // eslint-disable-line prefer-template
      }
    }

    if (path.indexOf('?') === -1) {
      url += '?';
    }

    url += params; // eslint-disable-line prefer-template
  }

  return fetch(url, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  });
};

module.exports = {
  loadSearchMatchesMember(query = '', isNextAfter = '') {
    let pathUrl = 'matches/get_member';
    if (query) {
      pathUrl += `?${query}`;
    }

    const requestData = {};
    if (isNextAfter) {
      requestData.exclude = isNextAfter;
    }

    requestApi(requestData, pathUrl).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined' && data.status === 'ok') {
        if (isNextAfter) {
          AppDispatcher.dispatch({
            type: ActionTypes.MATCHES_SEARCH_NEXT_SUCCESS,
            member: data.member,
          });
          return;
        }

        AppDispatcher.dispatch({
          type: ActionTypes.MATCHES_SEARCH_SUCCESS,
          member: data.member,
        });
      } else {
        console.log(data);
      }
    }).catch((data) => {
      console.log(data);
    });
  },
  matchesVote(memberId, vote, reloadMembers = {}) {
    //
    const formData = new FormData();
    formData.append('id', memberId);
    formData.append('vote', vote);

    //
    fetch('/apiv1/matches/vote', {
      method: 'post',
      credentials: 'include',
      body: formData,
    }).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined' && data.status === 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.MATCHES_VOTE_SUCCESS,
          vote: data.vote,
          loading: !_.isEmpty(reloadMembers),
          match: data.match || null,
          noAboLimitReached: data.noAboLimitReached || false,
        });

        if (!_.isEmpty(reloadMembers)) {
          this.loadMatchesMembers(
            reloadMembers.api,
            reloadMembers.page,
            reloadMembers.itemsPerPage,
          );
        }
      } else {
        console.log(data);
      }
    }).catch((data) => {
      console.log(data);
    });
  },
  loadMatchesMembers(api, page, itemsPerPage) {
    requestApi({ page }, api).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined') {
        if (data.status === 'ok') {
          AppDispatcher.dispatch({
            type: ActionTypes.MATCHES_LOAD_SUCCESS,
            matches: data.matches,
            unseen: data.unseen,
            total: data.total,
            page: data.page,
            itemsPerPage,
            members: data.members,
          });
        } else if (data.status === 'empty') {
          AppDispatcher.dispatch({
            type: ActionTypes.MATCHES_LOAD_EMPTY,
            message: data.message,
          });
        } else {
          AppDispatcher.dispatch({
            type: ActionTypes.MATCHES_LOAD_ERROR,
            message: data.status === 'error' ? (data.message || '') : '',
          });
        }
      } else {
        console.log(data);
        AppDispatcher.dispatch({
          type: ActionTypes.MATCHES_LOAD_ERROR,
        });
      }
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.MATCHES_LOAD_ERROR,
      });
    });
  },
};
